import PopupCore from './popup-core';

export default class CopyPopUp extends PopupCore {
    getActionText() {
        return null;
    }

    getActionIcon() {
        return null;
    }
}
